import { c as _c } from "react/compiler-runtime";
import { Hidden } from '@/components/Atoms/Hidden/Hidden';
import { SearchInput } from '@/components/Atoms/SearchInput/SearchInput';
import { ResultSection } from '@/components/Organisms/Navigation/Desktop/QuickSearch/ResultsSection';
import { PageContainer } from '@/components/Templates/PageContainer/PageContainer';
import { useGlobalSearchContext } from '@/contexts/GlobalSearchContext';
import useTranslation from '@/hooks/useTranslation';
import type { FCl } from 'react-fc';
import styled from 'styled-components';
export const QUICK_SEARCH_INPUT_ID = 'quick-search-input';
export const QuickSearch: FCl = t0 => {
  const $ = _c(15);
  const {
    className
  } = t0;
  const {
    activeQuery,
    setActiveQuery
  } = useGlobalSearchContext();
  const {
    t
  } = useTranslation("common");
  let t1;
  if ($[0] !== t) {
    t1 = t("Actions.search");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <Hidden as="label" htmlFor={QUICK_SEARCH_INPUT_ID}>{t1}</Hidden>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t) {
    t3 = t("Navigation.QuickSearch.placeholder");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== activeQuery || $[7] !== setActiveQuery || $[8] !== t3) {
    t4 = <SearchInput id={QUICK_SEARCH_INPUT_ID} name="q" maxLength={100} autoFocus={true} placeholder={t3} value={activeQuery} onChangeValue={setActiveQuery} suggestExactMatchAutoSubmit={false} />;
    $[6] = activeQuery;
    $[7] = setActiveQuery;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ResultWrap><ResultSection /></ResultWrap>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== className || $[12] !== t2 || $[13] !== t4) {
    t6 = <StyledQuickSearch as="form" method="get" action="/api/search/global-search" className={className}>{t2}{t4}{t5}</StyledQuickSearch>;
    $[11] = className;
    $[12] = t2;
    $[13] = t4;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
const ResultWrap = styled.div`
    overflow: auto;
    max-height: 60vh;
    padding-right: var(--size-grid-half);
`;
const StyledQuickSearch = styled(PageContainer)`
    > * {
        margin-bottom: var(--size-grid-unit);
        margin-top: var(--size-grid-unit);
    }
    input {
        font-size: var(--cds-font-heading-03-fontsize);
        & ~ button {
            align-self: stretch;
            font-size: 1em;
        }
    }
`;